import { render, staticRenderFns } from "./ImageNews.vue?vue&type=template&id=535dd2f0&scoped=true&"
import script from "./ImageNews.vue?vue&type=script&lang=js&"
export * from "./ImageNews.vue?vue&type=script&lang=js&"
import style0 from "./ImageNews.vue?vue&type=style&index=0&id=535dd2f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535dd2f0",
  null
  
)

export default component.exports